import { barcodeLabelSize } from "@redotech/redo-inventory-common/barcode-label";
import * as z from "zod";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  barcodeLabelSize,
  type BarcodeLabelSize,
} from "@redotech/redo-inventory-common/barcode-label";

const commonFields = z.object({
  productTitle: z.string().optional(),
  variantTitle: z.string().optional(),
  printerId: z.number().optional(),
  printerOptions: z.record(z.string(), z.unknown()).optional(),
  labelSize: z.enum(barcodeLabelSize).optional(),
});

const returnLookup = commonFields.extend({
  type: z.literal("return"),
  returnId: z.string().min(1),
  returnItemId: z.string().min(1),
});

const productLookup = commonFields.extend({
  type: z.literal("product"),
  productId: z.string().min(1),
});

export const generateLicensePlate = {
  name: "generateLicensePlate" as const,
  input: z.discriminatedUnion("type", [returnLookup, productLookup]),
  output: z.object({ pdfBase64: z.string(), printed: z.boolean().optional() }),
};
